import React from "react";
import slsdIcon from "../../assets/images/sLSD.svg"
import { Decimal, LiquityStoreState } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";

type ResultSelector = {
  totalCollateralUsdValue: Decimal
  totalDebtUsdValue: Decimal
}

const select = ({ collateralStates } : LiquityStoreState) => {
  const selected = Object.entries(collateralStates).reduce<ResultSelector>((acc, [key, value]) => {
    const { price, total } = value
    const totalCollateralUsdValue = total.collateral.mul(price)
    // TODO: need to fetch SLSD price from somewhere i.e. coingecko
    const totalDebtUsdValue = total.debt.mul(Decimal.ONE)

    acc.totalCollateralUsdValue = acc.totalCollateralUsdValue.add(totalCollateralUsdValue)
    acc.totalDebtUsdValue = acc.totalDebtUsdValue.add(totalDebtUsdValue)
    return acc
  }, { totalCollateralUsdValue: Decimal.ZERO, totalDebtUsdValue: Decimal.ZERO })
  return { ...selected }
}

export const TotalStats: React.FC = props => {
  const totalStats = useLiquitySelector(select);

  return (
    <div className="bg-component border-component p-6 flex flex-col justify-between h-fit">
      <div className="flex flex-col md:flex-row">
        <div className="col-span-1">
          <div className="text-style-sub-heading">Total Collateral</div>
          <div className="text-style-value mt-2">${totalStats.totalCollateralUsdValue.prettify(2)}</div>
        </div>
        <div className="mt-4 md:mt-0 md:ml-32">
          <div className="text-style-sub-heading">Total debt</div>
          <div className="text-style-value mt-2 flex flex-row">
            <img src={slsdIcon} alt="SLSD" className="w-8 h-8"/>
            <span className="ml-3">
              ${totalStats.totalDebtUsdValue.prettify(2)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};